export const UTILS__COMMON__delay = ms => new Promise(r => setTimeout(r, ms))

export const checkIsDefined = array => {
    let isErr = false
    for (const item of array) {
        if (typeof item === 'undefined') {
            isErr = true
            break
        }
    }
    return !isErr
}

export const uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    )
}
